import { faSignOut } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/AuthProvider';

export default function SideNav(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { logOut } = useAuth();
  console.log('====================================');
  console.log(location.pathname);
  console.log('====================================');
  return (
    <aside
      id='logo-sidebar'
      className='fixed top-0  start-0   z-30 w-64 h-screen pt-20 transition-transform -translate-x-full bg-white border-r border-gray-200 sm:translate-x-0 shadow-md'
      aria-label='Sidebar'>
      <div className='h-full  pb-4 overflow-y-auto bg-white'>
        <div className='flex h-full flex-col justify-between'>
          <h4 className='text-slate-400 text-xs font-light  ps-7 py-2'>{t('dashboard')}</h4>
          <ul className='  flex-col flex flex-grow gap-3 font-medium'>
            <li className=' items-center '>
              <a
                href={'/'}
                className={`flex items-center  py-4   ps-7  gap-3   text-gray-900    hover:bg-gray-100 group ${
                  location.pathname === '/'
                    ? ' border-e-4  bg-gradient-to-r from-[#F8F4EC] to-white border-[#B68A35]'
                    : ' '
                }`}>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M14.2544 1.36477C13.1584 1.05884 12.132 1.38956 11.4026 2.05979C10.6845 2.71963 10.25 3.70576 10.25 4.76087V11.4554C10.25 12.7228 11.2775 13.7503 12.5449 13.7503H19.2394C20.2945 13.7503 21.2806 13.3158 21.9405 12.5977C22.6107 11.8683 22.9414 10.8419 22.6355 9.74587C21.5034 5.69027 18.31 2.49687 14.2544 1.36477ZM11.75 4.76087C11.75 4.10956 12.0201 3.52942 12.4175 3.16432C12.8035 2.80959 13.3035 2.65668 13.8511 2.80954C17.4013 3.80055 20.1997 6.599 21.1907 10.1492C21.3436 10.6968 21.1907 11.1967 20.8359 11.5828C20.4708 11.9801 19.8907 12.2503 19.2394 12.2503H12.5449C12.1059 12.2503 11.75 11.8944 11.75 11.4554V4.76087Z'
                    fill='#000'
                  />
                  <path
                    d='M8.67232 4.71579C9.0675 4.59167 9.28724 4.1707 9.16312 3.77552C9.039 3.38034 8.61803 3.1606 8.22285 3.28472C4.18231 4.55378 1.25 8.32818 1.25 12.7894C1.25 18.2906 5.70962 22.7503 11.2108 22.7503C15.6721 22.7503 19.4465 19.8179 20.7155 15.7774C20.8397 15.3822 20.6199 14.9613 20.2247 14.8371C19.8296 14.713 19.4086 14.9328 19.2845 15.3279C18.2061 18.7613 14.9982 21.2503 11.2108 21.2503C6.53805 21.2503 2.75 17.4622 2.75 12.7894C2.75 9.00209 5.23899 5.79414 8.67232 4.71579Z'
                    fill='#000'
                  />
                </svg>
                <span className='ml-3'>{t('overview')}</span>
              </a>
            </li>
            <li className=' items-center '>
              <a
                href={'/feedbacks'}
                className={`flex items-center py-4  ps-7 gap-3   text-gray-900    hover:bg-gray-100   group ${
                  location.pathname === '/feedbacks'
                    ? ' border-e-4  bg-gradient-to-r from-[#F8F4EC] to-white border-[#B68A35]'
                    : ' '
                }`}>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M10.4606 1.25H13.5394C15.1427 1.24999 16.3997 1.24999 17.4039 1.34547C18.4274 1.44279 19.2655 1.64457 20.0044 2.09732C20.7781 2.57144 21.4286 3.22194 21.9027 3.99563C22.3554 4.73445 22.5572 5.57256 22.6545 6.59611C22.75 7.60029 22.75 8.85725 22.75 10.4606V11.5278C22.75 12.6691 22.75 13.564 22.7007 14.2868C22.6505 15.0223 22.5468 15.6344 22.3123 16.2004C21.7287 17.6093 20.6093 18.7287 19.2004 19.3123C18.3955 19.6457 17.4786 19.7197 16.2233 19.7413C15.7842 19.7489 15.5061 19.7545 15.2941 19.7779C15.096 19.7999 15.0192 19.832 14.9742 19.8582C14.9268 19.8857 14.8622 19.936 14.7501 20.0898C14.6287 20.2564 14.4916 20.4865 14.2742 20.8539L13.7321 21.7697C12.9585 23.0767 11.0415 23.0767 10.2679 21.7697L9.72579 20.8539C9.50835 20.4865 9.37122 20.2564 9.24985 20.0898C9.13772 19.936 9.07313 19.8857 9.02572 19.8582C8.98078 19.832 8.90399 19.7999 8.70588 19.7779C8.49387 19.7545 8.21575 19.7489 7.77666 19.7413C6.52138 19.7197 5.60454 19.6457 4.79957 19.3123C3.39066 18.7287 2.27128 17.6093 1.68769 16.2004C1.45323 15.6344 1.3495 15.0223 1.29932 14.2868C1.24999 13.564 1.25 12.6691 1.25 11.5278L1.25 10.4606C1.24999 8.85726 1.24999 7.60029 1.34547 6.59611C1.44279 5.57256 1.64457 4.73445 2.09732 3.99563C2.57144 3.22194 3.22194 2.57144 3.99563 2.09732C4.73445 1.64457 5.57256 1.44279 6.59611 1.34547C7.60029 1.24999 8.85726 1.24999 10.4606 1.25ZM6.73809 2.83873C5.82434 2.92561 5.24291 3.09223 4.77938 3.37628C4.20752 3.72672 3.72672 4.20752 3.37628 4.77938C3.09223 5.24291 2.92561 5.82434 2.83873 6.73809C2.75079 7.663 2.75 8.84876 2.75 10.5V11.5C2.75 12.6751 2.75041 13.5189 2.79584 14.1847C2.84081 14.8438 2.92737 15.2736 3.07351 15.6264C3.50486 16.6678 4.33223 17.4951 5.3736 17.9265C5.88923 18.1401 6.54706 18.2199 7.8025 18.2416L7.83432 18.2421C8.23232 18.249 8.58109 18.2549 8.87097 18.287C9.18246 18.3215 9.4871 18.3912 9.77986 18.5615C10.0702 18.7304 10.2795 18.9559 10.4621 19.2063C10.6307 19.4378 10.804 19.7306 11.0004 20.0623L11.5587 21.0057C11.7515 21.3313 12.2485 21.3313 12.4412 21.0057L12.9996 20.0623C13.1959 19.7306 13.3692 19.4378 13.5379 19.2063C13.7204 18.9559 13.9298 18.7304 14.2201 18.5615C14.5129 18.3912 14.8175 18.3215 15.129 18.287C15.4189 18.2549 15.7676 18.249 16.1656 18.2421L16.1975 18.2416C17.4529 18.2199 18.1108 18.1401 18.6264 17.9265C19.6678 17.4951 20.4951 16.6678 20.9265 15.6264C21.0726 15.2736 21.1592 14.8438 21.2042 14.1847C21.2496 13.5189 21.25 12.6751 21.25 11.5V10.5C21.25 8.84876 21.2492 7.663 21.1613 6.73809C21.0744 5.82434 20.9078 5.24291 20.6237 4.77938C20.2733 4.20752 19.7925 3.72672 19.2206 3.37628C18.7571 3.09223 18.1757 2.92561 17.2619 2.83873C16.337 2.75079 15.1512 2.75 13.5 2.75H10.5C8.84876 2.75 7.663 2.75079 6.73809 2.83873ZM7.25 9C7.25 8.58579 7.58579 8.25 8 8.25H16C16.4142 8.25 16.75 8.58579 16.75 9C16.75 9.41421 16.4142 9.75 16 9.75H8C7.58579 9.75 7.25 9.41421 7.25 9ZM7.25 12.5C7.25 12.0858 7.58579 11.75 8 11.75H13.5C13.9142 11.75 14.25 12.0858 14.25 12.5C14.25 12.9142 13.9142 13.25 13.5 13.25H8C7.58579 13.25 7.25 12.9142 7.25 12.5Z'
                    fill='#1C274C'
                  />
                </svg>

                <span className='ml-3'>{t('FeedBacks')}</span>
              </a>
            </li>
          </ul>
          <div className='flex'>
            <button
              onClick={() => {
                logOut();
                navigate('/login');
              }}
              className=' mx-4 ps-7 py-2.5 flex flex-row gap-5 justify-start  items-center w-full bg-slate-100  text-black rounded-xl'>
              <FontAwesomeIcon icon={faSignOut} color='black' />
              {t('logout')}
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
}
